import {
  ApiLegacyCustomElementResponse,
  ApiTransitionElementResponse,
  ApiTransitionStoryGroupResponse,
} from '../../../../../api/core/models';
import { ClientNode } from '../../../../../model/client-model/client-node';
import { IndicatorListItem } from '../../../../../model/indicator-list-item';
import { legacyCustomElementToClientNode } from './legacy-custom-element-to-client-node';
import { transitionElementToClientNode } from './transition-element-to-client-node';
import { transitionStoryGroupToClientNode } from './transition-story-group-to-client-node';
import { isLegacyCustomElement, isTransitionElement, isTransitionStoryGroup } from './utils';

export function createNodesAndIndicators(
  transitionElements: ApiTransitionElementResponse[],
  transitionHierarchy: ApiTransitionStoryGroupResponse[],
  boardId: string,
  baseUrlFiles?: string
): { nodes: ClientNode[]; indicators: IndicatorListItem[]; supplyElements: ClientNode[]; childNodes: string[] } {
  const hierarchyGroupToClientNodes = (
    acc: { nodes: ClientNode[]; indicators: IndicatorListItem[]; supplyElements?: ClientNode[] },
    group: ApiTransitionStoryGroupResponse | ApiTransitionElementResponse | ApiLegacyCustomElementResponse
  ): { nodes: ClientNode[]; indicators: IndicatorListItem[] } => {
    if (isTransitionStoryGroup(group)) {
      const node = transitionStoryGroupToClientNode(group, boardId, baseUrlFiles);
      acc.nodes.push(node);
      group.subTransitionStoryGroups?.reduce(hierarchyGroupToClientNodes, acc);
      group.transitionElements?.reduce(hierarchyGroupToClientNodes, acc);
      group.legacyCustomElements?.reduce(hierarchyGroupToClientNodes, acc);
    } else if (isTransitionElement(group)) {
      const elementFromStore = transitionElements.find((e) => e.id === group.id);
      const { node, indicator } = transitionElementToClientNode(
        group,
        elementFromStore ?? group,
        boardId,
        false,
        baseUrlFiles
      );
      acc.nodes.push(node);
      acc.indicators.push(indicator);
    } else if (isLegacyCustomElement(group)) {
      const { node, indicator } = legacyCustomElementToClientNode(group, boardId, baseUrlFiles);
      acc.nodes.push(node);
      acc.indicators.push(indicator);
    }

    return acc;
  };

  const { nodes, indicators } = transitionHierarchy.reduce(hierarchyGroupToClientNodes, {
    nodes: [],
    indicators: [],
  });

  const supplyElements =
    transitionElements
      .filter((e) => !nodes.some((n) => n.id === e.id))
      .map((e) => transitionElementToClientNode(e, e, boardId, true).node) ?? [];

  const childNodes = transitionHierarchy.map((e) => e.id);

  return { nodes: nodes, indicators, supplyElements, childNodes };
}
